export const STORAGE_TYPE = {
  ENTRANCE_URL: 'ENTRANCE_URL',
};
